var React = require('react');

function ShardTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1287.46 522L0 0.893066L1794 0.893127V318.641L1287.46 522Z","fill":"#2B40C7"}));
}

ShardTop.defaultProps = {"viewBox":"0 0 1794 522","fill":"none"};

module.exports = ShardTop;

ShardTop.default = ShardTop;
